<script>
import { VProgressCircular } from 'vuetify/lib';
export default VProgressCircular;
</script>
